export default __webpack_public_path__ + "static/media/logo_Qibo-10.ea7b88c3.png";